import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CompanySettingsServiceProvider {
	constructor(private http: HttpClient) {}

	deleteUser(userId: number): Observable<any> {
		const url = `/api/user/v1/company/user/${userId}/delete`;
		return this.http.post(url, {});
	}

	editCompany(dataToSend): Observable<any> {
		const url = '/api/user/company/settings';

		const headers = new HttpHeaders({
			'Cache-Control': 'no-cache, no-store, must-revalidate',
			Expires: '0',
			Pragma: 'no-cache'
		});

		return this.http.post(url, dataToSend, { headers });
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/settings/company-settings.ts